<template>
  <div class="container mx-auto sm:p-6">
    <graphql-requester
      :gql="$options.GET_SETTINGS"
      v-slot="{ data, loading }"
      @result="onResult"
    >
      <app-loading v-if="loading" />
      <div v-else-if="data && !loading">
        <sameday-header :form="form" />
        <component
          :is="component"
          :form="form"
          :search="search"
          @on:form="onForm"
          @on:back="onBack"
          @on:nextstep="$emit('onnextstep', $event)"
          @on:scroll="$emit('scroll-to', $event)"
          @onbookerror="$emit('onbookerror', $event)"
          @on:ocr_scan="$emit('on:ocr_scan', $event)"
          @on:submitted="$emit('on:submitted', $event)"
          @on:book_success="$emit('on:book_success', $event)"
        ></component>
      </div>
      <app-error v-else />
    </graphql-requester>
  </div>
</template>

<script>
import { GET_SETTINGS } from "@/graphql";
import GraphqlRequester from "@/components/GraphqlRequester";
import AppLoading from "@/components/AppLoading";
import AppError from "@/components/AppError";
import SamedayItems from "@/components/Sameday/SamedayItems.vue";
import SamedayForm from "@/components/Sameday/SamedayForm.vue";
import SamedayHeader from "@/components/Sameday/SamedayHeader.vue";

export default {
  GET_SETTINGS,
  components: {
    GraphqlRequester,
    SamedayItems,
    SamedayForm,
    SamedayHeader,
    AppLoading,
    AppError,
  },
  props: {
    search: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      view: "items",
      form: null,
    };
  },
  computed: {
    component() {
      return `sameday-${this.view}`;
    },
  },
  methods: {
    onForm(value) {
      if (this.view === "form") return;
      this.view = "form";
      this.form = value;
      this.onNextStep(this.form?.location?.location_id);
      this.$emit("scroll-to", "top");
    },
    onBack() {
      if (this.view === "items") return;
      this.view = "items";
      this.form = null;
    },
    onResult(data) {
      if (!data) return;
      const settings = data?.getScheduleDetails?.settings;

      this.$store.commit("fieldUpdate", {
        key: "settings",
        value: { ...settings },
      });
    },
    onNextStep(location_id) {
      this.$emit("onnextstep", {
        event: "scheduling-step",
        mode: "sameday",
        location_id,
        value: 1,
      });
    },
  },
};
</script>
